<template>
  <div>
    <side-bar>
      <!--подключаем юзерское меню UserMenuV2.vue-->
      <user-menu/>
      <hr class="uk-margin" />
      <template slot="links">
        <sidebar-item
            v-if="role === 'retoucher'"
            :link="{
              name: location_keys.menu_order,
              icon: 'wallpaper',
              path: '/new_mvp/order-new-idle-time',
            }"
        />
        <sidebar-item
            v-if="role === 'junior-retoucher'"
            :link="{
            //name: location_keys.menu_order_verification,
             name: location_keys.menu_order,
            icon: 'wallpaper',
            path: '/new_mvp/juniorRetoucherOrder',
          }"
        />
        <sidebar-item
            v-if="role === 'retoucher' || role === 'junior-retoucher'"
            :notification="notiferRetoucherRating"
            :link="{
            name: location_keys.menu_progress_report,
            icon: 'local_activity',
            path: '/new_mvp/retoucherProgressReport',
          }"
        />
        <sidebar-item
            v-if="role === 'pro-retoucher'"
            :link="{
            name: location_keys.menu_order_verification,
            icon: 'wallpaper',
            path: '/new_mvp/orderCheck',
          }"
        />
        <sidebar-item
            v-if="role === 'pro-retoucher' && ('education_pro_retoucher' in userProfile && userProfile.education_pro_retoucher)"
            :link="{
            // name: location_keys.menu_order_verification,
            name: 'Проверка заказов EDU',
            icon: 'school',
            path: '/new_mvp/orderCheckEducation',
          }"
        />
        <sidebar-item
            v-if="role === 'pro-retoucher' && ('education_pro_retoucher' in userProfile && userProfile.education_pro_retoucher)"
            :link="{
            // name: location_keys.menu_order_verification,
            name: 'История заказов EDU',
            icon: 'history_edu',
            path: '/new_mvp/orderEducationHistory',
          }"
        />
        <sidebar-item
            v-if="role === 'pro-retoucher'"
            :notification="notiferProRetoucherRating"
            :link="{
            name: location_keys.menu_progress_report,
            icon: 'local_activity',
            path: '/new_mvp/proRetoucherProgressReport',
          }"
        />
        <sidebar-item
            v-if="role === 'senior-retoucher'"
            :link="{
            name: location_keys.menu_order_verification,
            icon: 'wallpaper',
            path: '/new_mvp/seniorRetoucherOrderCheck',
          }"
        />

        <template v-if="role === 'test-retoucher'">
          <sidebar-item
              :link="{
              name: location_keys.menu_order_for_retoucher,
              icon: 'wallpaper',
              path: '/new_mvp/order_for_test_retoucher',
            }"
          />
          <sidebar-item
              :link="{
                name: location_keys.menu_order_verification_for_pro_retoucher,
                icon: 'wallpaper',
                path: '/new_mvp/orderCheck_for_test_retoucher',
              }"
          />
          <sidebar-item
              :link="{
                name: location_keys.menu_order_verification_for_senior_retoucher,
                icon: 'wallpaper',
                path: '/new_mvp/seniorRetoucherOrderCheck_for_test_retoucher',
              }"
          />
        </template>
        <sidebar-item
            :class="role === 'admin' || role === 'mini-admin' || role === 'senior-retoucher' ? 'tm-sidebar-scheduletable3' : ''"
            v-if="role === 'admin' || role === 'mini-admin' || role === 'senior-retoucher'"
            :link="{
              name: location_keys.menu_timetable,
              icon: 'calendar_month',
              path: '/components/scheduletable3',
            }"
        />
        <sidebar-item
            :class="role === 'admin' || role === 'mini-admin' || role === 'senior-retoucher' ? 'tm-sidebar-scheduletable4' : ''"
            v-if="role === 'retoucher' || role === 'junior-retoucher' || role === 'test-retoucher' || role === 'admin' || role === 'mini-admin' || role === 'senior-retoucher'"
            :link="{
              name: location_keys.menu_timetable,
              icon: 'calendar_month',
              path: '/components/scheduletable4',
            }"
        />
        <sidebar-item
            v-if="role === 'admin' || role === 'mini-admin' || role === 'senior-retoucher'"
            :link="{
              name: location_keys.menu_timetable,
              icon: 'work_history',
              path: '/components/scheduletable-pro',
            }"
        />
        <sidebar-item
            v-if="role === 'pro-retoucher'"
            :link="{
              name: location_keys.menu_timetable,
              icon: 'work_history',
              path: '/components/scheduletable-pro',
            }"
        />
        <sidebar-item
            v-if="role === 'admin' || role === 'mini-admin'"
            :link="{
              name: location_keys.menu_users,
              icon: 'people',
              path: '/components/users',
            }"
        />
        <sidebar-item
            v-if="role === 'admin'"
            :link="{
              name: location_keys.menu_localization,
              icon: 'language',
              path: '/components/translate',
            }"
        />
        <sidebar-item
            v-if="role === 'admin'"
              :link="{
              name: location_keys.menu_application_settings,
              icon: 'settings',
              path: '/components/startbonus',
            }"
        />
        <sidebar-item
            v-if="(role === 'admin' || role === 'senior-retoucher') && userProfile.email !== 'senior-retoucher03@retoucher.app'"
            :link="{
              name: location_keys.menu_salary_page,
              icon: 'request_quote',
              path: '/components/salary2',
            }"
        />
        <sidebar-item
            v-if="role === 'admin'"
            :link="{
              // name: location_keys.menu_elements_page,
              name: location_keys.menu_functions_list,
              icon: 'storage',
              path: '/new_mvp/functions_elements',
            }"
        />
        <sidebar-item
            v-if="role !== 'test-admin'"
            :link="{
              name: location_keys.menu_functions_description,
              icon: 'format_list_bulleted',
              path: '/new_mvp/functions_description',
            }"
        />
        <sidebar-item
            v-if="role === 'retoucher' || role === 'junior-retoucher'"
            :link="{
              name: location_keys.menu_wages,
              icon: 'request_quote',
              path: '/new_mvp/retoucherSalary',
            }"
        />
        <sidebar-item
            v-if="role === 'pro-retoucher'"
            :link="{
              name: location_keys.menu_wages,
              icon: 'request_quote',
              path: '/new_mvp/proretoucherSalary',
            }"
        />
        <sidebar-item
            v-if="role === 'admin' || role === 'mini-admin' || role === 'senior-retoucher' || role === 'test-admin' || role === 'tester'"
            :link="{
              name: location_keys.menu_admin_orders_history,
              icon: 'history',
              path: '/new_mvp/admin_orders_history',
            }"
        />
        <sidebar-item
            v-if="role === 'admin' || role === 'mini-admin' || role === 'senior-retoucher'"
            :link="{
              name: location_keys.menu_progress_report,
              icon: 'emoji_events',
              path: '/new_mvp/admin_progress_report',
            }"
        />
        <sidebar-item
            v-if="role === 'admin' || role === 'senior-retoucher' || role === 'mini-admin'"
            :link="{
              name: location_keys.menu_admin_reports,
              icon: 'functions',
              path: '/new_mvp/admin-reports',
            }"
        />
        <sidebar-item
            v-if="role === 'admin' || role === 'tester'"
            :link="{
              name: 'Аналитика по клиенту',
              icon: 'recent_actors',
              path: '/new_mvp/client-analytics',
            }"
        />
        <sidebar-item
            v-if="role === 'retoucher' || role === 'junior-retoucher'"
            :link="{
              name: location_keys.menu_acquaintance_with_the_account,
              icon: 'smart_display',
              path: '/new_mvp/acquaintance_with_the_account',
            }"
        />
      </template>
    </side-bar>

    <div class="main-panel">
      <div class="tm-padding-small 2">
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view />
        </zoom-center-transition>
      </div>
    </div>

  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import UserMenu from "./Extra/UserMenuV2.vue";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    UserMenu,
  },
  data() {
    return {
      image: process.env.VUE_APP_BASE_URL + "/img/laravel-vue.svg",
      role: '',
      userProfile: {},
      location_keys: {},
      getterKey:0,
      notiferProRetoucherRating: false,
      notiferRetoucherRating: false
    };
  },

  async created() {
    await this.getLocalizationDashBoard();
    await this.getRole();
    await this.getUserProfile();
    await this.dataForNotification();
    this.makeRetoucherNotification();
  },

  methods: {
    async getLocalizationDashBoard() {
      await this.$store.dispatch("localization/dashBoardLocal");
      this.location_keys = await this.$store.getters["localization/dashBoardLocal"];
    },
    logout() {
      this.$store.dispatch("logout");
    },
    async getUserProfile(){
      this.getterKey++;
      await this.$store.dispatch("profile/me");
      this.userProfile = this.$store.getters['profile/me'](this.getterKey);
      if(!this.userProfile) this.userProfile = {};
    },
    async getRole() {
      await this.$store.dispatch("profile/role");
      this.role = await this.$store.getters["profile/role"];
    },
    async checkLogout() {
      //await this.getRole();
    //  if (this.role === 'retoucher') {
        //const url = process.env.VUE_APP_API_BASE_URL;
        let start_time = localStorage.getItem('start_time');
        let difference = Date.now() - start_time;
        let differenceInMinutes = Math.floor(difference/1000/60);
        if (differenceInMinutes > 180) {
          localStorage.removeItem('start_time');
          this.logout();
        }else if(!start_time) {
          this.logout();
        }
      //}
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    async dataForNotification() {
      if (this.role !== 'pro-retoucher') {
        return;
      }
      await this.makeProRetoucherNotificationRequest();
      setInterval(async () => {
        await this.makeProRetoucherNotificationRequest();
      }, 5 * 60 * 1000);
    },
    async makeProRetoucherNotificationRequest() {
      try {
        await this.$store.dispatch('rating/proRetoucherNotificationData', {})
        let result = await this.$store.getters['rating/proRetoucherNotificationData'];
        this.notiferProRetoucherRating = result.data;

      } catch (error) {
        //console.error(error);
      }
    },
    makeRetoucherNotification() {
      const today = new Date();
      if (this.role === 'retoucher' && today.getDay() === 1)
        this.notiferRetoucherRating = true;
    }
  },

  updated() {
    this.checkLogout();
  },
  mounted() {
  },
  watch: {
  },
};
</script>